import { Injectable, NgZone } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { finalize, tap } from "rxjs/operators";
import { LoaderManagerService } from "../services/loader-manager.service";
import { HeaderFactoryService } from "../services/header-factory.service";
import { AuthenticationService, ConfigService } from "common";

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
  constructor(
    public loaderManagerService: LoaderManagerService,
    private router: Router,
    public ngZone: NgZone,
    private headerService: HeaderFactoryService,
    private authService: AuthenticationService,
    private configService: ConfigService,
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // add the default request level if not set
    request = this.loaderManagerService.handleEmptyRequestlevel(request);
    // set no cache headers if get
    if (request.method === 'GET' && request.url.indexOf('assets/svg') === -1) {
      request = this.loaderManagerService.setNoCacheHeaders(request);
    }
    if (request.body) {
      if (!request.headers.has('X-Request-Hash')) {
        request = request.clone({
          headers: request.headers.set('X-Request-Hash', this.headerService.getRequestHash(request.body))
        })
      }
      else if (request.headers.has('X-Request-Hash') && !request.headers.get('X-Request-Hash')) {
        request = request.clone({
          headers: request.headers.set('X-Request-Hash', this.headerService.getRequestHash(request.body))
        })
      }
    }
    request = this.headerService.ValidateAndManipulateHTTPHeaders(request);
   
    this.loaderManagerService.onRequestStart(request);

    let handleObs: Observable<HttpEvent<any>> = next.handle(request).pipe(
      finalize(() => {
        if (!request.headers.has('continueProgressForChainRequest')) {
          this.loaderManagerService.onRequestStop(request);
        }
      }),
    ).pipe(tap(() => { },
      (err: any) => {
        if (err instanceof HttpErrorResponse) {
          if (err.status !== 401) {
            return;
          }
          if (!this.router.url.includes('Public/Login')) {
            this.ngZone.run(() => {
              const sp = this.configService.getDefaultRoute;
              if (!!sp) {
                this.router.navigate([sp]);
              }
              else {
                window["skipPrompt"] = true;
                this.authService.logOut(true);
              }
            });
          }
        }
      }));
    return handleObs;
  }
}
